import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeOneComponent } from "./components/pages/home-one/home-one.component";
import { ContactPageComponent } from "./components/pages/contact-page/contact-page.component";
import { SignupPageComponent } from "./auth/pages/signup-page/signup-page.component";
import { LoginPageComponent } from "./auth/pages/login-page/login-page.component";
import { CheckoutPageComponent } from "./auth/pages/checkout/checkout.component";
import { checkoutAuthGuard } from "./auth/guards/checkout-auth.guard";

const routes: Routes = [
    { path: "", component: HomeOneComponent },
    { path: "contact", component: ContactPageComponent },
    { path: "auth/signup", component: SignupPageComponent },
    { path: "auth/login", component: LoginPageComponent },
    {
        path: "checkout",
        component: CheckoutPageComponent,
        canActivate: [checkoutAuthGuard],
    },
    {
        path: "**",
        redirectTo: "",
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            anchorScrolling: "enabled",
            scrollPositionRestoration: "top",
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
